import { useQuery } from "@apollo/client";
import {
  Box,
  CircularProgress,
  Dialog,
  DialogTitle,
  IconButton,
  Alert,
} from "@mui/material";
import {
  GetWarehouseServiceConfigDocument,
  WarehouseServiceOutput,
} from "../../../generated";
import { useParams } from "react-router-dom";
import ReactJson from "react-json-view";
import { Typography } from "../../Typography/Typography";
import { CloseButton } from "react-toastify/dist/components";
import { Button } from "../../Button/Button";
import { CloseIcon } from "../../Icons/CloseIcon";
import { CircularProgressCustom, DialogBox } from "./style";

export const WarehouseConfigModal = ({
  data,
  show,
  setShow,
}: {
  show: boolean;
  setShow: Function;
  data: WarehouseServiceOutput;
}) => {
  const { workspaceId } = useParams();

  const { data: warehouseConfig, loading } = useQuery(
    GetWarehouseServiceConfigDocument,
    {
      variables: {
        input: {
          workspaceId: workspaceId || "",
        },
        warehouseServiceFilter: {
          warehouseServiceId: data?.id || "",
        },
      },
    }
  );

  return (
    <Dialog
      open={show}
      onClose={() => setShow(false)}
      sx={{
        ".MuiPaper-elevation": {
          width: "100%",
          maxWidth: "600px",
          transform: "translateX(0px)",
          overflowX: "hidden",
        },
      }}
    >
      <DialogBox>
        <div className="head">
          <h2>Warehouse Configurations</h2>
          <IconButton
            aria-label="close"
            onClick={() => setShow(false)}
            sx={(theme) => ({
              position: "absolute",
              right: 8,
              top: 8,
              color: theme.palette.grey[500],
            })}
          >
            <CloseIcon />
          </IconButton>
        </div>
        <div className="content">
          {loading && <CircularProgressCustom />}
          {!loading &&
            (warehouseConfig ? (
              <ReactJson
                src={{ configuration: warehouseConfig }}
                enableClipboard={(e) =>
                  navigator.clipboard.writeText(
                    JSON.stringify({ [e?.name || ""]: e.src })
                  )
                }
              />
            ) : (
              <Alert severity="warning">
                No configuration found for this warehouse service.
              </Alert>
            ))}
        </div>
        <div className="footer">
          <Button
            variant="outlined"
            className="red"
            onClick={() => setShow(false)}
          >
            Close
          </Button>
        </div>
      </DialogBox>
    </Dialog>
  );
};
